// extracted by mini-css-extract-plugin
module.exports = {"copiedTooltip":"SocialMediaIcon_copiedTooltip__9p6n1"};